if ($('.js-padding-left').length){
    $(window).on('resize', function () {
        resizeFunction();
    });

    resizeFunction();

    function resizeFunction() {
        $(".js-padding-left").css('padding-left', '');
        var pl = window.scrollX + document.querySelector('.js-parent-news').getBoundingClientRect().left;
        $('.js-padding-left').css('padding-left',pl);
        $('.js-padding-left').css('padding-right','20px');
    }
}